import { Button } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { PropsGoToPaymentTemplate } from './props'

import { ButtonWrapper } from './styles'

const GoToPaymentTemplate = ({
    buttonText,
    canGoToPayment,
    onClickGoToPayment,
}: PropsGoToPaymentTemplate): ReactElement => (
    <ButtonWrapper>
        <Button
            css={{
                ...(!canGoToPayment && {
                    bc: '$secondary400',
                    bgc: '$secondary400',
                    color: '$primary400',

                    '&:hover': {
                        bc: '$secondary400',
                        bgc: '$secondary400',
                        color: '$primary400',
                    },
                }),
            }}
            data-cy="detailsCTA"
            size="large"
            variant="success"
            onClick={onClickGoToPayment}
        >
            {buttonText}
        </Button>
    </ButtonWrapper>
)

export default GoToPaymentTemplate
